module.exports = __webpack_public_path__ + "img/blood_button2.bd845a18.jpg";